export const dialogConstants = {
  CLOSE_DIALOG: "CLOSE",
  OPEN_DIALOG: "OPEN",
  OPEN_ALTER_DIALOG: " OPEN_ALTER_DIALOG",
};
